import { createAction } from '@lifesize/typescript-react-redux-utils';
import { PaginationActionType } from '../constants/paginationConstants';

const actions = {
  setPageNumber: (payload: Number) =>
    createAction(PaginationActionType.PAGINATION_SET_PAGE_NUMBER, payload),
};

export default actions;
